export class IChild {
  id?: string = null;
  firstName?: string = null;
  middleName?: string = null;
  lastName?: string = null;
  phone?: string = null;
  dateOfBirth?: string = null;
  street?: string = null;
  line1?: string = null;
  line2?: string = null;
  city?: string = null;
  state?: string = null;
  zip?: string = null;
  ssn?: string = null;
  ratio?: number = null;
  lastZipCode?: string = null;
  email?: string = null;
}
